import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import { getHeaders, checkStatus } from "../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL;

// For fetching the record of Conversation Service.
export const postTimeSheet = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/Add`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getTimeSheet = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/Get`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getProjectTimeSheet = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Project/Get`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getTimeSheetStatus = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/Status/Get`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getWeekStartandEnd = async () => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/WeekStartandEnd`,{}, {
      headers: await getHeaders(),
      // body: JSON.stringify()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const postTimeSheetDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/DeleteByTaskId`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const postTimeStatusUpdate = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/Status/Update`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getProjectClient = async () => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Project/Clients`,{}, {
      headers: await getHeaders(),
      body: JSON.stringify()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getTimeSheetSummary = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/Summary/Get`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const postTimeSheetWeek = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/TimeSheet/Clone/Week`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const getManagerList = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Employee/Manager/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}